module.exports = __webpack_public_path__ + "img/carshina21_06.e987b16f.jpg";